import { Column } from '../signature-table.types';

export const mySignaturesColumnsConfig = {
  stickyColumns: [Column.DOCUMENT_NAME] as Column[],
  scrollableColumns: [Column.CATEGORY, Column.STATUS, Column.EXPIRY, Column.ACTIONS] as Column[],
  sortableColumns: [Column.DOCUMENT_NAME, Column.EXPIRY] as Column[],
} as const;
